import { useErrorHandler, useHttpClient, useTranslation } from '@wix/fe-essentials/react';
import { chunk } from 'lodash';
import { useCallback } from 'react';
import { fetchBulkAltTextSuggestions } from '../api/suggestion-apis/fetch-bulk-alt-text-suggestions';
import { fetchSingleAltTextSuggestions } from '../api/suggestion-apis/fetch-single-alt-text-suggestions';
import { enqueueRequest } from './alt-text-generation/request-queue';
const CHUNK_SIZE = 80;
export const useSuggestionsData = () => {
  const httpClient = useHttpClient();
  const errorHandler = useErrorHandler();
  const {
    t
  } = useTranslation();
  const getSingleSuggestionsData = useCallback(async (itemType, imageData) => {
    const req = {
      image: imageData,
      itemType
    };
    try {
      const data = await enqueueRequest(() => fetchSingleAltTextSuggestions(httpClient, errorHandler, t, req));
      return {
        suggestions: data.suggestions ?? []
      };
    } catch (err) {
      console.error('single-alt-text error', err);
      return {
        errorMessage: errorHandler.getResolvedError(err).message,
        suggestions: []
      };
    }
  }, [httpClient, errorHandler, t]);
  const getMultipleSuggestionsData = useCallback(async (itemType, images) => {
    const chunks = chunk(images, CHUNK_SIZE);
    const promises = chunks.map(slice => enqueueRequest(() => fetchBulkAltTextSuggestions(httpClient, {
      images: slice,
      itemType
    })).catch(error => {
      console.error('bulk-alt-text error', error);
      return [];
    }));
    const results = await Promise.all(promises);
    return results.flat();
  }, [httpClient]);
  return {
    getMultipleSuggestionsData,
    getSingleSuggestionsData
  };
};
//# sourceMappingURL=use-suggestions-data.js.map